import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './InventoryTransfers.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryTransfers_get_inventory_transfer_lines_statesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { inventoryTransferLineIds: number[] }): Promise<{ lines?: { status: { id: number, name: string, state: string, eventError?: string }, failActions: { updateReasons: string[], deleteReasons: string[], cancelReasons: string[] }, line: { id: number, number: number, inventoryTransferId: number } }[], reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.inventoryTransferLineIds)) {
      missingRequiredInParams.push('\'inventoryTransferLineIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransfers/functions/get_inventory_transfer_lines_states`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

